import { useContext, useState } from "react";
import { Tooltip } from "@mui/material";
import Chip from '@mui/material/Chip';

import { Context } from "../../../Provider";
import { theme } from "../../../../../theme";
import PersonalDocumentsFiles from "./PersonalDocumentsFiles";
import { timestampToDate } from "../../../../../utils";
import { commonSwal } from "../../../../../components/swalAlert/swalAlert";

const PersonalDocuments = () => {
    const { state, dispatch } = useContext(Context);
    const { ftm } = state;
    const { ftm_id, ftm_personal_documents } = ftm;

    const [selectedItem, setSelectedItem] = useState(null);
    const [showPersonalDocumentModal, setShowPersonalDocumentModal] = useState(false);

    const handleShowPersonalDocumentModal = () => setShowPersonalDocumentModal(true);
    const handleClosePersonalDocumentModal = () => setShowPersonalDocumentModal(false);

    const handleSelectedPersonalDocument = (document, documentIsExpired) => {
        if(documentIsExpired){
            commonSwal({
                notificationType: "OPEN_NEW_DOCUMENT_TYPE",
                isConfirmed: async () => {
                    setSelectedItem({
                        ...document,
                        is_get_new_document_files: false
                    });
                    handleShowPersonalDocumentModal();
                },
                isDenied: async () => {
                    setSelectedItem({
                        ...document,
                        is_get_new_document_files: true
                    });
                    handleShowPersonalDocumentModal();
                },
            });
        }else{
            setSelectedItem({
                ...document,
                is_get_new_document_files: false
            });
            handleShowPersonalDocumentModal();
        }
        // setSelectedItem(document);
        // handleShowPersonalDocumentModal();
    }

    const renderDocumentItem = (item, index) => {
        const expiryDate =
            item?.document?.ftm_personal_document_expiry_date
                ? timestampToDate(
                    item?.document?.ftm_personal_document_expiry_date
                )
                : "N/A";

        const documentIsExpired = item?.document?.ftm_personal_document_is_expired === 1;
        const haveNewDocument = item?.document?.ftm_personal_new_document_id > 0;

        return (
            <li
                className="list-group-item border-0 d-flex justify-content-between ps-0 mb-2 border-radius-lg cursor-pointer hover-row ps-2"
                key={index}
                onClick={() => handleSelectedPersonalDocument(item, documentIsExpired)}
            >
                <div className="d-flex align-items-center">
                    <div className={`btn btn-icon-only btn-rounded btn-outline-${haveNewDocument ? 'warning' : theme.main} mb-0 me-3 p-3 btn-sm d-flex align-items-center justify-content-center`}>
                        <i className="material-icons text-lg">{item.document_type_icon}</i>
                    </div>
                    <div className="d-flex flex-column">
                        <div className="d-flex justify-content-between align-items-center w-100">
                            {/* LEFT SIDE */}
                            <h6 className="mb-1 text-dark text-sm d-flex align-items-center">
                                {item.document_type_name}

                                {item?.document?.ftm_personal_document_comment && (
                                    <Tooltip
                                        title={item?.document?.ftm_personal_document_comment}
                                        arrow
                                        placement="right"
                                    >
                                        <i className={`material-icons text-sm opacity-10 text-${theme.main} ms-2`}>
                                            chat_bubble
                                        </i>
                                    </Tooltip>
                                )}
                            </h6>

                            {/* RIGHT SIDE */}
                            {documentIsExpired && (
                                <Chip
                                    label="Document validity has ended."
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                        color: 'red',
                                        borderColor: 'red'
                                    }}
                                />
                            )}
                        </div>

                        <span className="text-xs">Expiry Date: {expiryDate}</span>
                        <span className="text-xs">{item.personal_document_type_description}</span>
                    </div>
                </div>
                {item.document.ftm_personal_document_is_approve === 1 && (
                    <div className={`d-flex align-items-center text-${theme.main} text-gradient text-sm font-weight-bold ms-3`}>
                        <i
                            className={`material-icons opacity-10 text-${theme.main}`}
                            aria-label="verified"
                        >
                            verified
                        </i>
                    </div>
                )}
            </li>
        );
    };

    return (
        <div className="card h-100 mb-4">
            <div className="card-header pb-0 px-3">
                <div className="row">
                    <div className="col-md-6">
                        <h6 className="mb-0">Documents888</h6>
                    </div>
                </div>
            </div>
            <div className="card-body pt-4 p-3">
                <ul className="list-group">
                    {ftm_personal_documents.map((item, index) => renderDocumentItem(item, index))}
                </ul>
            </div>

            <PersonalDocumentsFiles
                show={showPersonalDocumentModal}
                handleClose={handleClosePersonalDocumentModal}
                ftm_id={ftm_id}
                item={selectedItem}
                personalDocumentsHandleRefresh={() => dispatch({ type: "SET_FTM_EDIT_COUNT" })}
            />
        </div>
    );
};

export default PersonalDocuments;